import React from "react";
import { Tooltip, styled, tooltipClasses } from "@mui/material";
import { useSelector } from "react-redux";
import "./TranscriptionButton.css";
import transcribeIcon from "../../../../assets/live-transcribe.svg";
import transcribeActiveIcon from "../../../../assets/live-transcribe-green.svg";
import transcribePendingIcon from "../../../../assets/live-transcribe-orange.svg";
import { useTranslation } from "react-i18next";

/**
 * @param {{ anchorEl?: unknown, onToggle: () => void }} props
 * onToggle : doit appeler le service + fermer le menu « plus » (MediaControlPanel).
 */

export default function TranscriptionButton({ anchorEl, onToggle }) {
  const { t } = useTranslation()
  const { TSstatus, isOwner, TSChecking } = useSelector(
    (state) => state.transcription
  );

  /*-------------- LOGIC -------------- */
  const PeoplmapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
      zIndex: 10009,
      [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: '#ffffff',
          color: '#000000',
          fontSize: '0.875rem',
          borderRadius: '0.5rem',
          padding: '0.5rem 0.75rem',
          fontFamily: '"Roboto", sans-serif',
          zIndex: 10009,
          boxShadow: '0 0.5rem 1.375rem rgba(0, 0, 0, 0.18)',
      },
      [`& .${tooltipClasses.arrow}`]: {
          color: '#ffffff',
          zIndex: 10009,
      },
  }));

  const getTooltipTitle = () => {
    switch (TSstatus) {
      case "active":
        return t("stop_transcription");
      case "inactive":
        return t("active_transcription");
      case "pending":
        return t("waiting");
      default:
        return t("unkown");
    }
  };

  const getIcon = () => {
    switch (TSstatus) {
      case "active":
        return transcribeActiveIcon;
      case "inactive":
        return transcribeIcon;
      case "pending":
        return transcribePendingIcon;
      default:
        return transcribeIcon;
    }
  };

  /*--------------Tooltip-height---------*/
  const getTooltipOffset = (panelElement) => {
    return ({ reference }) => {
      if (!panelElement) return [0, 10];
      const panelRect = panelElement.getBoundingClientRect();
      const distance = (reference.y - panelRect.y) / 2;
      return [0, distance];
    };
  };
  return (
      <span className="d-block">
        <button
           type="button"
           onClick={() => onToggle?.()}
          disabled={
            TSstatus === "pending" ||
            (TSstatus === "active" && !isOwner) ||
            TSChecking
          }
          className={`control-btn transcribe-button ${TSstatus === "active"
              ? "icon-transcribe-active"
              : TSstatus === "pending"
                ? "icon-transcribe-pending"
                : ""
            }`}
        >
          <img src={getIcon()} alt="Transcribe" /> <span className="label-btn">Transcription</span>
        </button>

      </span>

  );
}
